import axios from 'axios';
import { apiRoutes } from './routes';

// credentials => {email, password}
export const authenticateUser = async credentials => {
    try {
        const response = await axios.request({
            baseURL: process.env.REACT_APP_API_BASE_URL,
            url: apiRoutes.auth.local,
            method: 'post',
            data: credentials,
        });
        return response.data;
    } catch (e) {
        // No HTTP response at all: network failure, CORS block, timeout, or a
        // request the browser never sent. Say so rather than dereferencing
        // e.response, which surfaced on the login screen as
        // "Cannot read properties of undefined (reading 'status')".
        if (!e.response) {
            throw new Error(
                `Could not reach the server (${e.message}). Check your connection and try again.`,
            );
        }
        // handle known errors
        if (e.response.status === 401) {
            throw new Error('Incorrect username or password');
        }
        throw new Error(e.message);
    }
};
